import API from "../../api/api";
import { Link } from "react-router-dom";
import React, { Component } from "react";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import "../../styles/css/ProjectCards/HeaderCard.css";
import { IconButton } from "@material-ui/core";

const userRole = localStorage.getItem("userRole");
const userRoleId = localStorage.getItem("userRoleId");
const token = localStorage.getItem("token");

class HeaderCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cronology: "null",
      surveyType: "",
      searchKey: "",
      cronologyType: [{ name: "Latest" }],
      surveyTypeList: [{ name: "A" }],
    };
  }

  componentDidMount() {
    this.loadSurveyTypes();
  }

  loadSurveyTypes = () => {
    API.get("job/survey_types")
      .then((res) => {
        this.setState({ surveyTypeList: res.data.response });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  handleInputChange = (event) => {
    this.setState({ searchKey: event.target.value });
  };

  selectCronologyHandle = (event) => {
    this.setState({ cronology: event.target.value });
  };
  selectSurveyTypeHandle = (event) => {
    this.setState({ surveyType: event.target.value });
  };

  render() {
    // const { cronologyType, surveyTypeList } = this.state;

    return (
      <div className="headerCardRoot">
        <div className="headerCardMain">
          <div className="headerCardTitle">
            {token && token.length > 0 ? (
              <span>Dashboard</span>
            ) : (
              <span>Browse jobs</span>
            )}
          </div>
          <div className="headerCardBody">
            {/* <Select
                            value={this.state.cronology}
                            onChange={this.selectCronologyHandle}
                            className={`headerCardInputs`}
                            inputProps={{
                                name: 'cronology',
                                id: 'selectUserState',
                            }}
                        >
                            <MenuItem value={'null'}>Select C</MenuItem>
                            {cronologyType
                                .map(cr => {
                                    return (
                                        <MenuItem key={cr.name} value={cr.name}>{cr.name}</MenuItem>
                                    );
                                })
                            }
                        </Select> */}
            {/* <Select
              defaultValue={""}
              value={this.state.surveyType}
              onChange={this.selectSurveyTypeHandle}
              className={`headerCardInputs`}
              inputProps={{
                name: "surveyType",
                id: "selectUserState",
              }}
            >
              <MenuItem defaultValue value={""}>
                All
              </MenuItem>
              {surveyTypeList.map((typeList) => {
                return (
                  <MenuItem key={typeList.name} value={typeList.id}>
                    {typeList.name}
                  </MenuItem>
                );
              })}
            </Select> */}
            <div className="headerSearchDiv">
              <TextField
                id="searchKey"
                label="Search jobs"
                className="headerSearch"
                fullWidth
                margin="normal"
                name="searchKey"
                value={this.state.searchKey}
                onChange={this.handleInputChange}
              />
              <IconButton
                onClick={() =>
                  this.props.searchJobs(
                    this.state.searchKey,
                    this.state.surveyType
                  )
                }
              >
                <SearchIcon />
              </IconButton>
            </div>
            <div
              className="cardHeaderButtons"
              style={{ display: userRole === null ? "none" : "block" }}
            >
              <div className="cardButtonLinks">
                {/* {(userRole === "Admin" ||
                  userRole === "Title Company Admin") && (
                  <Link
                    to="/companyUserMgt"
                    className="currLink manageUsersLink"
                  >
                    Manage users
                  </Link>
                )} */}
                {userRoleId === "1" || userRoleId === "2" ? (
                  <Link
                    to="/companyUserMgt"
                    className="currLink manageUsersLink"
                  >
                    <button className="greyColorBtn">Manage users</button>
                  </Link>
                ) : null}
                {(userRole === "Title Company Admin" ||
                  userRole === "Title Company User" ||
                  userRole === "Admin") && (
                  <Link
                    to="/JobCreation/0"
                    className="currLink manageUsersLink"
                  >
                    <button className="bidBtn createJobBtn">
                      Create a job
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderCard;



// WEBPACK FOOTER //
// ./src/components/ProjectCards/HeaderCard.js